
















































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ConnectionDto } from '@/shared/dtos/agents-admin';

@Component
export default class ConnectionsTab extends Vue {
    @Prop() public connections: ConnectionDto[] = [];
    @Prop() public loading: boolean = false;

    get activeConnections(): number {
        return this.connections.filter(c => c.connection_status === 1).length;
    }

    get inactiveConnections(): number {
        return this.connections.filter(c => c.connection_status !== 1).length;
    }

    get sortedConnections(): ConnectionDto[] {
        return [...this.connections].sort((a, b) => {
            if (a.is_current && !b.is_current) return -1;
            if (!a.is_current && b.is_current) return 1;
            const dateA = new Date(a.connected_at_utc || 0).getTime();
            const dateB = new Date(b.connected_at_utc || 0).getTime();
            return dateB - dateA;
        });
    }

    get connectionsByAgent(): { [key: string]: ConnectionDto[] } {
        const grouped: { [key: string]: ConnectionDto[] } = {};
        this.sortedConnections.forEach(conn => {
            const agentId = conn.agent_id || 'Sin agente';
            if (!grouped[agentId]) {
                grouped[agentId] = [];
            }
            grouped[agentId].push(conn);
        });
        return grouped;
    }

    get groupedAgents(): string[] {
        return Object.keys(this.connectionsByAgent).sort();
    }

    public getStatusClass(status: number): string {
        return status === 1 ? 'status-connected' : 'status-disconnected';
    }

    public getStatusColor(status: number): string {
        return status === 1 ? 'green' : 'red';
    }

    public getStatusIcon(status: number): string {
        return status === 1 ? 'mdi-link' : 'mdi-link-off';
    }

    public getStatusText(status: number): string {
        return status === 1 ? 'Conectado' : 'Desconectado';
    }

    public getStatusTextClass(status: number): string {
        return status === 1 ? 'text-green' : 'text-red';
    }

    public truncateId(id: string, length: number = 20): string {
        return id.length > length ? id.substring(0, length) + '...' : id;
    }

    public formatDate(date: Date | string | null): string {
        if (!date) return 'N/A';
        const d = new Date(date);
        return d.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    public calculateDuration(connection: ConnectionDto): string {
        const start = new Date(connection.connected_at_utc || new Date()).getTime();
        const end = connection.disconnected_at_utc
            ? new Date(connection.disconnected_at_utc).getTime()
            : new Date().getTime();

        const diffMs = end - start;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffDays > 0) return `${diffDays}d ${diffHours % 24}h`;
        if (diffHours > 0) return `${diffHours}h ${diffMins % 60}m`;
        return `${diffMins}m`;
    }

    public copyToClipboard(text: string): void {
        navigator.clipboard.writeText(text).then(() => {
            this.$emit('notification', {
                type: 'success',
                message: 'Connection ID copiado al portapapeles'
            });
        });
    }
}
